export const TitleSub = ({
  title,
  subtitle,
  titleClassName,
  subtitleClassName,
  className,
}: {
  title: string;
  subtitle: string;
  titleClassName?: string;
  subtitleClassName?: string;
  className?: string;
}) => {
  return (
    <div className={`${className}`}>
      <p className={`font-medium text-base leading-6 ${titleClassName}`}>
        {title}
      </p>

      <p className={`text-sm text-pry-dark-green-300/50 ${subtitleClassName}`}>
        {subtitle}
      </p>
    </div>
  );
};
